import { makeStyles, createStyles } from "@material-ui/core";
import { useCallback } from "react";
import { DropzoneArea } from "material-ui-dropzone";

const useStyles = makeStyles((theme) =>
	createStyles({
		previewChip: {
			minWidth: 160,
			maxWidth: 210,
			display: "flex",
		},
	})
);

const Dropzones = (props) => {
	const { setState, type } = props;
	const maxSize = 5000000;
	const classes = useStyles();

	const onDrop = useCallback(
		(acceptedFiles) => {
			if (acceptedFiles.length !== 0) {
				setState(acceptedFiles);
			} else {
				setState({ file: acceptedFiles });
			}
		},
		[setState]
	);

	return (
		<div style={{ width: "100%" }}>
			{type === "formontask" ? (
				<DropzoneArea
					acceptedFiles={["image/png"]}
					filesLimit={4}
					previewGridProps={{
						container: { spacing: 1, direction: "row" },
						item: { xs: "6", sm: "auto", md: "auto", lg: "auto", xl: "6" },
					}}
					maxFileSize={maxSize}
					previewChipProps={{ classes: { root: classes.previewChip } }}
					previewText="Selected files"
					onChange={(files) => onDrop(files)}
				/>
			) : type === "initial" ? (
				<DropzoneArea
					acceptedFiles={["image/png"]}
					filesLimit={1}
					previewGridProps={{
						container: { spacing: 1, direction: "row" },
						item: { xs: "6", sm: "auto", md: "auto", lg: "auto", xl: "6" },
					}}
					maxFileSize={maxSize}
					previewChipProps={{ classes: { root: classes.previewChip } }}
					previewText="Selected files"
					onChange={(files) => onDrop(files)}
				/>
			) : (
				<DropzoneArea
					acceptedFiles={["image/png"]}
					showPreviews={true}
					showPreviewsInDropzone={false}
					useChipsForPreview
					filesLimit={4}
					maxFileSize={maxSize}
					previewGridProps={{
						container: { spacing: 1, direction: "row" },
						item: { xs: "6", sm: "auto", md: "auto", lg: "auto", xl: "6" },
					}}
					previewChipProps={{ classes: { root: classes.previewChip } }}
					previewText="Selected files"
					onChange={(files) => onDrop(files)}
				/>
			)}
		</div>
	);
};

export default Dropzones;
